import { Card, CardBody, Col } from "reactstrap";
import { Image } from "src/AbstractElements";
import { dynamicImage } from "src/Service";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { autoPlayData, autoPlayDataList } from "../../../../Data/BonusUi/Carousel/Carousel";
import { AutoPlayVariants } from "../../../../utils/Constant";

const AutoPlayVariant = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={AutoPlayVariants} span={autoPlayData} />
        <CardBody>
          <Swiper pagination={{ clickable: true }} autoplay={{ delay: 2500, disableOnInteraction: false }} modules={[Autoplay, Pagination]}>
            {autoPlayDataList.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(item.image)} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AutoPlayVariant;
